import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import SplashScreen from 'app/shared/components/common/SplashScreen';
import _ from 'lodash';

import { PATH_LOGIN } from 'constants/authPaths';
import { logger } from 'utils/logger';

import { autoLoginAction, logoutMasterAction } from 'store/auth/actions';
import { getMasterRole, selectIsBrokerCompany } from 'store/auth/selectors';
import { showErrorMessageAction } from 'store/global/actions';

import { AUTO_LOGIN_ERROR_MESSAGE } from './AutoLogin.constants';
import {
  extractSourceModeFromToken,
  parseAutoLoginTokensFromSearch,
  resolveAutoLoginHomePath,
} from './AutoLogin.utils';

const AutoLogin = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const masterRole = useSelector(getMasterRole);

  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) {
      return;
    }

    hasProcessedRef.current = true;

    const autoLoginTokens = parseAutoLoginTokensFromSearch(search);

    history.replace(pathname);

    if (!autoLoginTokens) {
      logger.info('AutoLogin: no token provided in URL');
      history.replace(PATH_LOGIN);

      return;
    }

    const { token, refreshToken, refreshTokenExpiresAt } = autoLoginTokens;

    if (!_.isNull(masterRole)) {
      dispatch(logoutMasterAction({ skipRedirect: true }));
    }

    const sourceMode = extractSourceModeFromToken(token);

    dispatch(autoLoginAction(token, refreshToken, refreshTokenExpiresAt))
      .then(() => {
        const isBrokerCompany = selectIsBrokerCompany(store.getState());
        const homePath = resolveAutoLoginHomePath({ sourceMode, isBrokerCompany });

        history.replace(homePath);
      })
      .catch(error => {
        const message = _.get(error, 'response.data') || AUTO_LOGIN_ERROR_MESSAGE;

        dispatch(showErrorMessageAction({ message, err: error }));
        history.replace(PATH_LOGIN);
      });
  }, [dispatch, history, masterRole, pathname, search, store]);

  return <SplashScreen />;
};

export default AutoLogin;
